import React, { Suspense } from "react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import { Box } from "@chakra-ui/core";
import { ProfilePage } from "../pages/Dashboard/Profile/ProfilePage";
import Page404 from "../pages/Page404";
import ProfileSettings from "../pages/Dashboard/Profile/ProfileSettings";
import CreateProfilePage from "../pages/CreateProfilePage";
import { InvestorHomePage } from "../pages/Dashboard/Investor/InvestorHome";
import UploadAvatar from "../pages/Dashboard/Investor/UploadAvatar";

export const InvestorDashboardNavigator = (props) => {
  const { path } = useRouteMatch();

  console.log(path);

  return (
    <Box onClick={props.toggle}>
      <Switch>
        <Route path={`${path}/me`} component={ProfilePage} />

        <Route path={`${path}/create-profile`} component={CreateProfilePage} />

        <Route path={`${path}/settings`} component={ProfileSettings}></Route>
        <Route path={`${path}/me/upload-picture`} component={UploadAvatar} />
        {/* <Route path={`${path}/jobs`} component={JobsPage} /> */}

        <Route path={path} exact>
          <InvestorHomePage />
        </Route>
        <Route path={`${path}/page-not-found`} component={Page404} />

        <Redirect to={`${path}/page-not-found`} />
      </Switch>
    </Box>
  );
};
